import React from 'react'
import { ReactComponent as ReportStreetLightIcon } from '../../assets/icons/ui/report-streetlight.svg'
import { ReactComponent as BillInsertIcon } from '../../assets/icons/ui/bill_insert.svg'
import { ReactComponent as EnergyStatsIcon } from '../../assets/icons/ui/energy-stats.svg'
import { ReactComponent as OutageFaqsIcon } from '../../assets/icons/ui/outage-FAQs.svg'
import { NavCard } from "../../components"
import { useHistory } from "react-router-dom"
import { services } from '../../services'
const { auth } = services 

const signInRequest = {   
  scopes: ["openid"],
  extraQueryParameters: {
    region: "nyupstate",
    customer_type: "home",
    switch_uri: process.env.REACT_APP_IAM_SWITCH_URL,
  },
}
const LandingPage = function () {
  const BILLING_WEB_URL = process.env.REACT_APP_BILLING_ACCOUNT_URL
  const FAQ_CONTENT_WEB_URL = process.env.REACT_APP_CONTENT_WEB_FAQ
  const history = useHistory()
 
  const outageAction = () => history.push('/OutageWarning')
  const inventoryAction = () =>{ //history.push('/InventoryAccount')
    auth.setAuthority(process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY)
    auth.loginRedirect(signInRequest)
  }

  const faqsAction = () => { window.location.href=FAQ_CONTENT_WEB_URL }
  const billAction = () => { window.open(BILLING_WEB_URL, "_blank") }
  const navLinks = [{
    icon: <ReportStreetLightIcon />, title: 'Street Light Outage',
    description: 'Report Street Light Issues', buttonText: 'Outage', action: outageAction,
  },
  {
    icon: <EnergyStatsIcon />, title: 'Inventory',
    description: 'Request for current inventory and list of components',
    buttonText: 'Inventory', action: inventoryAction,
  },
  {
    icon: <OutageFaqsIcon />, title: 'FAQs',
    description: 'Questions and answers about streetlighting',
    buttonText: 'FAQ', action: faqsAction,
  },
  {
    icon: <BillInsertIcon />, title: 'Billing',
    description: 'Access your current monthly streetlight bill',
    buttonText: 'Billing', action: billAction,
  },
  ]
   
  return (
    <div className="page-content">
      <h1 className="report-outage__title"  data-test="landingComponent">Streetlight Portal</h1>
      <span className = "report-outage-sub-heading">Welcome to Streetlight Inventory Management System (SIMS)</span>
      <ul className="nav-list">
        {navLinks.map(navLink => (<NavCard {...navLink} key={navLink.buttonText} />))}
      </ul>
    </div>
  )
  
}
export default LandingPage